import classNames from 'classnames';
import * as React from 'react';
import { Link } from '../Link/Link';
import { LinkType } from '../Link/LinkType.csharp';
import type { LinkViewModel } from '../Link/LinkViewModel.csharp';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import styles from './Shortcut.module.css';
import type { ShortcutSize } from './ShortcutSize';
import type { ShortcutType } from './ShortcutType';
import type { ShortcutVariant } from './ShortcutVariant';

export interface ShortcutProps {
    type?: ShortcutType;
    variant?: ShortcutVariant;
    size?: ShortcutSize;
    className?: string;
}

export const Shortcut: React.FC<React.PropsWithChildren<LinkViewModel & ShortcutProps>> = props => {
    const { label, type = 'outline', variant = 'light', size = 'large', className, href } = props;

    return (
        <Link
            href={href}
            showIsExternal={false}
            type={LinkType.Clear}
            className={classNames(
                styles.Shortcut,
                styles[`Variant--${variant}`],
                styles[`VariantType--${type}`],
                styles[`VariantSize--${size}`],
                className
            )}
            labelClassName={styles.LinkLabel}
        >
            <span className={styles.Label}>{label}</span>
            <SvgIcon iconName="arrow-right" />
        </Link>
    );
};
